// extracted by mini-css-extract-plugin
export default {"preloader":"styles_preloader__Q5E3w","spinner":"styles_spinner__Ouw8q","spin":"styles_spin__kMWwx"};